define('presentation/settings/autoAttendant/presentationObjects/subMenuPresentationObject',[],function() {
    return function(){
        var self = this;

        self.subMenuId = null;
        self.isInitialVoiceRoute = null;
        self.subMenuItems = [];
    };
});
